import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import {getUrlForGeneratedAiChatModelAssetsImage} from '@Libraries/ai-chat.library';
import {MediaItemSizeType} from '@Libraries/s3-library';
import {ChangeStyleSource} from '../../change-style-dropdown.types';
import {ImageLabelTile} from '../image-label-tile/image-label-tile';
import type {ChangeStyleSourceSelectorProps} from './change-style-source-selector.types';
import styles from './change-style-source-selector.module.scss';

export function ChangeStyleSourceSelector({originalImageHashedId, currentImageHashedId, selectedSource, onSourceSelect}: ChangeStyleSourceSelectorProps): ReactElement {
  const getSourceTile = (source: ChangeStyleSource, imageHashedId: string, label: string): ReactElement => {
    const handleSelect = (): void => {
      onSourceSelect(source);
    };

    return (
      <ImageLabelTile
        imageUrl={getUrlForGeneratedAiChatModelAssetsImage(imageHashedId, MediaItemSizeType.THUMB)}
        label={label}
        onClick={handleSelect}
        isSelected={selectedSource === source}
      />
    );
  };

  return (
    <div className="flex-v-row gap-2">
      <Text val={window.i18next.t('pmwjs_ai_chat_change_style_source_heading')} size={TextSize.SM} bold />
      <div className={styles.sourceOptions}>
        {getSourceTile(ChangeStyleSource.ORIGINAL, originalImageHashedId, window.i18next.t('pmwjs_original'))}
        {getSourceTile(ChangeStyleSource.CURRENT, currentImageHashedId, window.i18next.t('pmwjs_ai_chat_change_style_current_design'))}
      </div>
    </div>
  );
}
